(() => {
  const setup = () => document.querySelectorAll('.header__inline-menu header-menu > details > .header__submenu').forEach(menu => {
    if (menu.dataset.kovFlyoutReady) return;
    menu.dataset.kovFlyoutReady = 'true';
    const branches = [...menu.querySelectorAll(':scope > li > details')];
    const openBranch = branch => {
      branches.forEach(other => { if (other !== branch) other.open = false; });
      const panel = branch.querySelector(':scope > ul');
      if (panel) menu.style.setProperty('--kov-panel-height', (panel.scrollHeight + 24) + 'px');
    };
    branches.forEach(branch => {
      branch.addEventListener('toggle', () => { if (branch.open) openBranch(branch); });
      branch.querySelector('summary').addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(min-width:990px)').matches) {
          branch.open = true;
          openBranch(branch);
        }
      });
      branch.querySelector('summary').addEventListener('click', event => {
        if (event.detail > 0 && matchMedia('(min-width:990px)').matches) {
          event.preventDefault(); branch.open = true; openBranch(branch);
        }
      });
      branch.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' && event.target.tagName === 'SUMMARY') {
          event.preventDefault(); branch.open = true; openBranch(branch);
          branch.querySelector('a')?.focus();
        } else if (event.key === 'ArrowLeft' || event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation(); branch.open = false;
          branch.querySelector('summary').focus();
        }
      });
    });
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();